import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    id: null,
    role: "",
    phone: "",
    email: "",
    nickname: "",
    image: null,
    token: null,
  },
  isAuthenticated: false,
};
const isBrowser = typeof window !== "undefined";
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const { id, role, phone, nickname, personal_email, image, token } =
        action.payload;
      state.user = {
        id,
        role,
        phone,
        email: personal_email,
        nickname,
        image,
        token,
      };
      state.isAuthenticated = true;
    },
    logout: state => {
      state.user = {
        id: null,
        role: "",
        phone: "",
        email: "",
        nickname: "",
        image: null,
        token: null,
      };
      state.isAuthenticated = false;
    },
    updateProfile: (state, action) => {
      state.user = Object.assign({}, state.user, action.payload);
    },
  },
});

export const { login, logout, updateProfile } = authSlice.actions;
export const selectUser = state => state.auth.user;

export default authSlice.reducer;
